import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export default function PaymentSuccess() {
  const [sp] = useSearchParams();
  const sid = sp.get("session_id");
  const [status, setStatus] = useState("polling");
  const [tries, setTries] = useState(0);
  const [kind, setKind] = useState(null);

  useEffect(() => {
    if (!sid) { setStatus("error"); return; }
    let t;
    const poll = async () => {
      try {
        const r = await api.get(`/payments/status/${sid}`);
        setKind(r.data.kind);
        if (r.data.payment_status === "paid") { setStatus("paid"); return; }
        if (tries > 10) { setStatus("timeout"); return; }
        setTries(x => x+1);
        t = setTimeout(poll, 2000);
      } catch { setStatus("error"); }
    };
    poll();
    return () => t && clearTimeout(t);
  }, [sid, tries]);

  return (
    <div className="max-w-md mx-auto px-4 py-16 text-center">
      <div className="glass-strong rounded-2xl p-8">
        {status === "polling" && <>
          <Loader2 className="mx-auto animate-spin text-[#F59E0B]" size={36}/>
          <p className="mt-4 text-slate-300">Confirmation du paiement…</p>
        </>}
        {status === "paid" && <>
          <CheckCircle2 className="mx-auto text-emerald-400" size={48}/>
          <h1 className="font-display text-2xl font-bold mt-3">Paiement confirmé</h1>
          <p className="text-sm text-slate-400 mt-2">{kind === "escrow" ? "Fonds gelés en séquestre." : "Contact débloqué ! Retrouvez-le dans vos messages."}</p>
          <Link to="/messages" data-testid="pay-goto-messages" className="mt-6 inline-block btn-coral px-4 py-2 rounded-lg text-sm">Voir mes messages</Link>
        </>}
        {(status === "error" || status === "timeout") && <>
          <XCircle className="mx-auto text-red-400" size={48}/>
          <p className="mt-3 text-slate-300">{status === "timeout" ? "Le paiement prend plus de temps que prévu." : "Erreur."}</p>
          <Link to="/search" className="mt-4 inline-block btn-ghost-glass px-4 py-2 rounded-lg text-sm">Retour</Link>
        </>}
      </div>
    </div>
  );
}
